<template>
<v-container style="background-color: #2f363e;"  fluid>
<v-row style="background-color: #2f363e;" justify="end" align="end">
  <v-col style="background-color: #393E46;" cols="12">
    <loginboxmobile :paises="paises" :desconectado="desconectado" :browser="browser" :abreviado="abreviado" :ttnegocios="ttnegocios"  :tpromotor="tpromotor" :tsuperadmin="tsuperadmin" :tsocio="tsocio" />
  </v-col></v-row>
</v-container>

    </template>
<script>

import Loginboxmobile from "@/components/modals/loginboxmobile";
import firebase from 'firebase/compat/app';
import store from "@/store";
import axios from "axios";
import tipoentrjson from "@/assets/json/tipoentradas.json";
import tipopagjson from "@/assets/json/tipopagos.json";
import tipoevenjson from "@/assets/json/tipoeventos.json";
import tipomembrjson from "@/assets/json/tipomembresias.json";
import sexosjson from "@/assets/json/sexos.json";
import estadocarjson from "@/assets/json/estadocarnet.json";
import diasjson from "@/assets/json/dias.json";
import {mapGetters} from "vuex";

  export default {
    name: 'cabecerabaja',
    components: {
      Loginboxmobile
    },
    data: () => ({
    links: [
      {'url':'Contactenos', 'href':'#contact' },
    ],
        paises:[],
    ttnegocios:false,
    tpromotor:false,
    tsocio:false,
    abreviado:'NN',
      desconectado: true,
    browser:false,
    tsuperadmin: false,
    tokencaptcha:''
  }),
    mounted() {
      this.ttnegocios = this.$store.state.tnegocios
      this.overlayLogin = true
      this.getPaises();
      this.fnBrowserDetect();
      if(this.usuario.id === undefined){
        firebase
            .auth()
            .onAuthStateChanged(user => {
              if(user){
                this.tpromotor = this.usuario.promotor
                this.tsocio = this.usuario.socio
                this.tsuperadmin = this.usuario.superAdmin

                this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
                this.recaptcha(user)
                this.overlayLogin = false
              }else{
                this.overlayLogin = false
              }
            })
      }else{
        this.tpromotor = this.usuario.promotor
        this.tsocio = this.usuario.socio
        this.tsuperadmin = this.usuario.superAdmin

        this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
        this.desconectado = false
        this.abreviado = this.usuario.nombre.charAt(0) + this.usuario.apellidoPaterno.charAt(0)
        this.negociospromotor = this.pnegocios
        store.dispatch("conectarse")
        this.overlayLogin = false

      }
    },
    methods:{
      getPaises(){
        axios.get("paises/activos",{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
            .then(response=>{
              this.paises = response.data
            })
      },
      fnBrowserDetect(){

        let userAgent = navigator.userAgent;

        if(userAgent.match(/chrome|chromium|crios/i)){
          this.rese = "chrome";
          this.browser = true;
        }else if(userAgent.match(/firefox|fxios/i)){
          this.rese = "firefox";
          this.browser = true;
        }  else if(userAgent.match(/safari/i)){
          this.rese = "safari";
          this.browser = true;
        }else if(userAgent.match(/opr\//i)){
          this.rese = "opera";
          this.browser = true;
        } else if(userAgent.match(/edg/i)){
          this.rese = "edge";
          this.browser = true;
        }else{
          this.rese="No browser detection";
          this.browser = false;
        }

      },
      async recaptcha(user) {
        // (optional) Wait until recaptcha has been loaded.
        await this.$recaptchaLoaded()

        // Execute reCAPTCHA with action "login".
        this.tokencaptcha = await this.$recaptcha('login')
        // Do stuff with the received token.
        if(this.tokencaptcha !=='' ){
          this.logeo(user)
        }

      },
      logeo(user){
        var bodyFormData = new FormData();
        bodyFormData.append('uuid', user.uid);
        bodyFormData.append('token', this.tokencaptcha);


        this.overlayLogin = true
        axios.post("personas/loginbyuid",bodyFormData,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
            .then(response => {
              store.dispatch("fetchUsuario", response.data.persona);

              if(response.data.usuarionegocio!==null){
                store.dispatch("fetchNegocios", response.data.usuarionegocio);
                store.dispatch("connegocios")
                localStorage.negocios = true
                this.ttnegocios = true
              }else{
                store.dispatch("sinnegocios")
                this.ttnegocios = false
                localStorage.negocios = false
              }
              if(response.data.clientes!==null){
                store.dispatch("fetchClientes", response.data.clientes);
                store.dispatch("fetchCliente", response.data.clientes[0]);
                this.teventos = true
                localStorage.eventos = true

              }else{
                store.dispatch("fetchCliente", response.data.usuarionegocio.negocio[0].cliente);
                this.teventos = false
                localStorage.eventos = false
              }
              this.tsuperadmin = response.data.persona.superAdmin

              store.dispatch("fetchTipoEntradas", tipoentrjson);
              store.dispatch("fetchTipoPagos", tipopagjson);
              store.dispatch("fetchTipoEventos", tipoevenjson);
              store.dispatch("fetchTipoMembresias", tipomembrjson);
              store.dispatch("fetchSexos", sexosjson);
              store.dispatch("fetchEstadoCarnets", estadocarjson);
              store.dispatch("fetchDias", diasjson);
              store.dispatch("conectarse");
              this.desconectado = false;
              this.overlayLogin = false;
              this.dialog=false;
              this.tpromotor = response.data.persona.promotor
              this.abreviado = response.data.persona.nombre.charAt(0) + response.data.persona.apellidoPaterno.charAt(0)
            })
            .catch(error => {
              this.overlayLogin = false;
              console.log(error);
            });
      }
    },
    computed: {
      // map `this.user` to `this.$store.getters.user`
      ...mapGetters({
        usuario: "usuario",
        cliente: "cliente",
        clientes:"clientes",
        pnegocios: "pnegocios",
        conectado: "conectado",
        negocios: "negocios",
        tnegocios: "tnegocios",
        grupousuarios: "grupousuarios"
      })
    }
  }
</script>
